/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum NotificationType {
  success = 0,
  info = 1,
  warning = 2,
  error = 3,
}
